import React, { FunctionComponent } from 'react';
import { StyleSheet, Text } from 'react-native';
import Theme from '../../../theme';
import { defaultScale } from '../../../utils';

interface IProps {
  heading: string;
}

const LeaderboardSectionHeading: FunctionComponent<IProps> = (
  {
    heading,
  },
) => (
  <Text style={styles.heading}>
    {heading}
  </Text>
);

const styles = StyleSheet.create({
  heading: {
    ...Theme.textStyle.heading2,
    paddingHorizontal: defaultScale(18),
    marginTop: defaultScale(20),
    marginBottom: defaultScale(10),
  },
});

export default LeaderboardSectionHeading;
